export function getFilenameContentType(filename) {
    var _a;
    const extension = '.' + ((_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    const mimeTypeMap = {
        '.png': 'image/png',
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.pdf': 'application/pdf',
        '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.xlsm': 'application/vnd.ms-excel.sheet.macroenabled.12'
    };
    return mimeTypeMap[extension] || '';
}
